<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex user-form__shell">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap user-form__grid">
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >First Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="firstName"
                  v-model="formValues.firstName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Father Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="fatherName"
                  v-model="formValues.middleName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Grandfather Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z][A-Za-z ]*$',
              }"
            >
              <input
                  id="grandFatherName"
                  v-model="formValues.lastName"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >User Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="username"
                  v-model="formValues.username"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="text"
                  @input="formValues.username = formValues.username.toLowerCase()"
                  @keydown.space.prevent
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Email Address</label
            >
            <validation-provider v-slot="{ errors }" rules="required|email">
              <input
                  id="emailAdress"
                  v-model="formValues.email"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                mode="eager"
                :rules="{
                required: true,
                phone_regex: '^\\+251[97]\\d{8}$',
              }"
            >
              <input
                  id="phoneNumber"
                  v-model="formValues.phoneNumber"
                  inputmode="numeric"
                  maxlength="13"
                  class="
                  shadow
                  appearance-none
                  border
                  rounded
                  w-full
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                  name
                  placeholder="+2519xxxxxxx"
                  type="tel"
                  @input="onPhoneInput('phoneNumber', $event.target.value, true)"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >User Group</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.userGroupId"
                  :elevation="1"
                  :items="GROUPS"
                  :loading="loading"
                  dense
                  item-text="groupName"
                  item-value="id"
                  solo
                  @change="groupOnChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Role</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.userRoleId"
                  :elevation="1"
                  :items="FILTERED_ROLES"
                  :loading="roleLoading"
                  dense
                  item-text="roleName"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showRegion"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Region</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.regionId"
                  :elevation="1"
                  :items="REGIONS"
                  :loading="defaultsLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
                  @change="regionChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Facility Type</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.facilityTypeId"
                  :disabled="requiresEducationalInstitutionFacilityType"
                  :elevation="1"
                  :items="facilityTypeOptions"
                  :loading="facilityTypeLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
                  @change="facilityTypeChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showFacility"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >{{ FACILITY_TYPES.find(type => Number(type.id) === Number(formValues.facilityTypeId))?.code === "RHB" ? "Regional health bureau" : "Facility" }}</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.userFacilityId"
                  :elevation="1"
                  :items="FILTERED_USER_FACILITIES"
                  :loading="facilityLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showCpdProvider"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >CPD Provider</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete v-model="formValues.cpdProviderId" :clearable="clearable" :elevation="1"
                              :items="FILTERED_CPD_PROVIDERS"
                              :loading="facilityLoading" :searchable="searchable" dense item-text="trainingCenterName"
                              item-value="id"
                              label="cpd providers" solo></v-autocomplete>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="showAccreditor"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Accreditors</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select v-model="formValues.accreditorId" :clearable="clearable" :elevation="1"
                        :items="FILTERED_ACCREDITORS" :loading="facilityLoading" :searchable="searchable" dense
                        item-text="accreditorName"
                        item-value="id" solo></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div v-if="showEduInstitutions" class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Educational Institutions</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.eduInstitutionId"
                  :elevation="1"
                  :items="UNIVERSITIES"
                  :loading="universityLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="!formValues.editMode"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Password</label
            >
            <validation-provider
                v-slot="{ errors }"
                rules="required"
                vid="confirm"
            >
              <div class="input-icons">
                <!-- <input class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                " v-if="showPassword" type="text" v-model="formValues.password" name="password" /> -->
                <input
                    v-model="formValues.password"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                    type="password"
                />
                <password
                    v-model="formValues.password"
                    :showPassword="true"
                    :strength-meter-only="true"
                />
              </div>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div
              v-if="!formValues.editMode"
              class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required"
          >
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >Confirm Password</label
            >
            <validation-provider
                v-slot="{ errors }"
                rules="required|confirmed:confirm"
            >
              <div class="input-icons">
                <input
                    v-if="showConfirmPassword"
                    v-model="confirmPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                    name="confirm"
                    type="text"
                />
                <input
                    v-else
                    v-model="confirmPassword"
                    class="
                  input-field
                  shadow
                  appearance-none
                  border
                  rounded
                  py-2
                  px-3
                  text-gray-700
                  leading-tight
                  focus:outline-none focus:shadow-outline
                "
                    name="confirm"
                    type="password"
                />

                <a class="button" @click="toggleConfirmShow()">
                  <v-icon v-if="showConfirmPassword">
                    mdi-eye-off
                  </v-icon>
                  <v-icon v-else>
                    mdi-eye
                  </v-icon>
                </a>
              </div>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="
                block
                uppercase
                tracking-wide
                text-gray-700 text-xs
                font-bold
                mb-2
              "
            >User's Status</label
            >
            <validation-provider v-slot="{ errors }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-switch
                      v-model="formValues.isActive"
                      color="green"
                      hide-details
                      v-on="on"
                  ></v-switch>
                </template>
                <span>{{
                    formValues.isActive == true ? "Active" : "Not Active"
                  }}</span>
              </v-tooltip>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
        </div>

        <div class="flex flex-wrap user-form__actions">
          <div class="w-full">
            <button
                class="
                user-form__submit
                float-right
                shadow
                focus:shadow-outline focus:outline-none
                font-bold
                py-2
                px-4
                rounded
              "
                type="button"
                @click="submit()"
            >
              {{ formValues.editMode ? "Update User" : "Create User" }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {accessPolicy} from "@/utils/managedAccess";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {normalizeEthiopianPhone} from "@/utils/phone";
import {confirmed, email, regex, required} from "vee-validate/dist/rules";
import {RoleService} from "../Role/role.service";
import {UserGroupService} from "../UserGroup/Usergroup.service";
import {TrainingCenterService} from "../../TrainingCenter/training_center.service";
import {AccreditorService} from "../../Accreditors/accreditor.service";
import {getExpertLevels, getFacilityTypes, getRegionList, getUniversities, getUserFacilities, getUser,} from "@/utils/helper";
import Password from "vue-password-strength-meter";

const PRESERVICE_ADMIN_ROLE_NAME = "pre-service admins";
const PRESERVICE_UNIVERSITY_USER_ROLE_NAME = "pre-service university users";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("regex", {
  ...regex,
  message: "Names should contain only letters",
});
extend("phone_regex", {
  ...regex,
  message: "Use +251 then 9 or 7 and 8 digits (e.g. +2519xxxxxxx).",
});
extend("email", {
  ...email,
  message: "Email must be valid",
});

extend("confirmed", {
  ...confirmed,
  message: "Password doesn't match",
});

export default {
  props: {
    user: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Password,
  },
  data() {
    return {
      formValues: {
        firstName: "",
        middleName: "",
        lastName: "",
        username: "",
        password: "",
        phoneNumber: "",
        email: "",
        userRoleId: null,
        regionId: null,
        expertLevelId: 2,
        userGroupId: null,
        isActive: true,
        facilityTypeId: null,
        userFacilityId: null,
        eduInstitutionId: null,
        cpdProviderId: null,
        accreditorId: null,
        editMode: false,
      },
      showProgress: false,
      // ROLES: [],
      FILTERED_ROLES: [],
      // defaultGroups: null,
      GROUPS: [],
      REGIONS: [],
      EXPERT_LEVELS: [],
      showRegion: true,
      FACILITY_TYPES: [],
      selectedRegion: null,
      FILTERED_USER_FACILITIES: [],
      FILTERED_CPD_PROVIDERS: [],
      FILTERED_ACCREDITORS: [],
      selectedFacilityType: null,
      facilityLoading: false,
      roleLoading: false,
      defaultsLoading: false,
      showPassword: false,
      showConfirmPassword: false,
      confirmPassword: null,
      UNIVERSITIES: [],
      universityLoading: false,
      educationalInstId: null,
      cpdProviderId: null,
      accreditorId: null,
      showEduInstitutions: false,
      showCpdProvider: false,
      showAccreditor: false,
      showFacility: false,
      facilityTypeLoading: false,
      clearable: true,
      searchable: true
    };
  },
  async beforeMount() {
    this.loading = true;
    this.defaultsLoading = true;
    const res = await UserGroupService.getUserGroups();
    if (res.status === 200) {
      this.loading = false;
      this.GROUPS = res.data.rows;
    } else {
      this.loading = false;
      this.$toast.error(
          "There was a problem fetching roles, Please try Again!"
      );
    }
    this.REGIONS = await getRegionList();
    this.EXPERT_LEVELS = await getExpertLevels();
    this.defaultsLoading = false;
  },
  async created() {
    this.facilityTypeLoading = true;
    this.universityLoading = true;
    this.FACILITY_TYPES = await getFacilityTypes();
    this.facilityTypeLoading = false;
    const univResp = await getUniversities();
    this.UNIVERSITIES = (univResp.rows && univResp.rows.length > 0) ? univResp.rows.filter((data) => {
      return data.isActive === true;
    }) : null;
    this.universityLoading = false;
    const educationInstitutionFacilityType = this.FACILITY_TYPES.find((data) => data.code == "EINST");
    const cpdProviderFacilityType = this.FACILITY_TYPES.find((data) => data.code == "CPDPF");
    const accreditorFacilityType = this.FACILITY_TYPES.find((data) => data.code == "ACCF");

    this.educationalInstId = educationInstitutionFacilityType?.id ?? null;
    this.cpdProviderId = cpdProviderFacilityType?.id ?? null;
    this.accreditorId = accreditorFacilityType?.id ?? null;

    if (this.user != null) {
      this.formValues = this.user;
      this.formValues.editMode = true;
      this.formValues.userFacilityId = +this.user.userFacilityId;
      this.formValues.facilityTypeId = +this.user.facilityTypeId;
      this.formValues.userRoleId = +this.user.userRoleId;
      this.formValues.userFacilityId = +this.user.userFacilityId;

      this.groupOnChange(this.formValues.userGroupId);
      // this.epxertLevelChange(this.formValues.expertLevelId);
      this.regionChange(this.formValues.regionId, 'init');
      if (this.requiresEducationalInstitutionFacilityType) {
        await this.applyPreserviceFacilityDefaults('init');
      } else {
        await this.facilityTypeChange(this.formValues.facilityTypeId, 'init');
      }
    } else if (this.requiresEducationalInstitutionFacilityType) {
      await this.applyPreserviceFacilityDefaults();
    }
    this.formValues.phoneNumber = normalizeEthiopianPhone(this.formValues.phoneNumber, {forcePrefix: true});
  },
  computed: {
    assignedOrganization() { return accessPolicy(getUser())?.organization || null; },
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    isPreserviceAdmin() {
      if (accessPolicy(getUser())) return false;
      const roleName = (getUser()?.data?.userRoles?.roleName || "")
          .toString()
          .trim()
          .toLowerCase();

      return roleName === PRESERVICE_ADMIN_ROLE_NAME;
    },
    selectedRoleName() {
      return (this.FILTERED_ROLES.find((role) => Number(role.id) === Number(this.formValues.userRoleId))?.roleName || "")
          .toString()
          .trim()
          .toLowerCase();
    },
    requiresEducationalInstitutionFacilityType() {
      if (this.assignedOrganization) return ["education-admin","institution"].includes(this.assignedOrganization.kind);
      return this.isPreserviceAdmin
          || this.selectedRoleName === PRESERVICE_ADMIN_ROLE_NAME
          || this.selectedRoleName === PRESERVICE_UNIVERSITY_USER_ROLE_NAME;
    },
    facilityTypeOptions() {
      if (this.requiresEducationalInstitutionFacilityType && this.educationalInstId) {
        return this.FACILITY_TYPES.filter((data) => Number(data.id) === Number(this.educationalInstId));
      }

      const scope = this.assignedOrganization;
      const codes = {regional:"RHB",provider:"CPDPF",accreditor:"ACCF",institution:"EINST","education-admin":"EINST"};
      return codes[scope?.kind] ? this.FACILITY_TYPES.filter(type => type.code === codes[scope.kind]) : this.FACILITY_TYPES;
    },
  },
  watch: {
    "formValues.userRoleId": async function () {
      if (this.requiresEducationalInstitutionFacilityType) {
        await this.applyPreserviceFacilityDefaults();
      }
    },
  },
  methods: {
    onPhoneInput(field, value, forcePrefix = false) {
      const normalized = normalizeEthiopianPhone(value, {forcePrefix});
      if (normalized !== this.formValues[field]) {
        this.formValues[field] = normalized;
      }
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmShow() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    async applyPreserviceFacilityDefaults(from = null) {
      if (!this.requiresEducationalInstitutionFacilityType || !this.educationalInstId) {
        return;
      }

      this.formValues.facilityTypeId = Number(this.educationalInstId);
      this.selectedFacilityType = Number(this.educationalInstId);
      await this.facilityTypeChange(this.educationalInstId, from);
    },
    async groupOnChange(event) {
      this.roleLoading = true;
      const groupId = event;
      const res = await RoleService.getRolesByGroupId(groupId);
      if (res.status === 200) {
        this.loading = false;
        this.FILTERED_ROLES = res.data;

        this.roleLoading = false;
        if (this.requiresEducationalInstitutionFacilityType) {
          await this.applyPreserviceFacilityDefaults();
        }
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching roles, Please try Again!"
        );

        this.roleLoading = false;
      }
    },
    regionChange(value, from) {
      if (this.showRegion == true) {
        this.selectedRegion = value;
        if (from !== 'init') {
          this.FILTERED_USER_FACILITIES = [];
          this.FILTERED_CPD_PROVIDERS = [];
          this.FILTERED_ACCREDITORS = [];
          this.formValues.accreditorId = null;
          this.formValues.cpdProviderId = null;
          this.formValues.userFacilityId = null;
          this.formValues.eduInstitutionId = null;
        }
        this.selectedFacilityType
            ? this.facilityTypeChange(this.selectedFacilityType)
            : null;
      } else {
        this.selectedRegion = 0;
      }
    },
    async facilityTypeChange(value, from) {
      if (from !== 'init') {
        this.formValues.accreditorId = null;
        this.formValues.cpdProviderId = null;
        this.formValues.userFacilityId = null;
        this.formValues.eduInstitutionId = null;
      }
      this.facilityLoading = true;
      if (value == this.educationalInstId) {
        this.showEduInstitutions = true;
        this.showAccreditor = false;
        this.showCpdProvider = false;
        this.showFacility = false;
        this.selectedFacilityType = +value;
      } else if (value == this.cpdProviderId) {
        this.showEduInstitutions = false;
        this.showCpdProvider = true;
        this.showAccreditor = false;
        this.showFacility = false;
        this.selectedFacilityType = +value;
        const returnedCpdProvider = await TrainingCenterService.getTrainingCentersByLocation(this.selectedRegion);
        this.FILTERED_CPD_PROVIDERS = returnedCpdProvider.filter((data) => {
          return data.isActive == true;
        });
      } else if (value == this.accreditorId) {
        this.showEduInstitutions = false;
        this.showCpdProvider = false;
        this.showAccreditor = true;
        this.showFacility = false;
        this.selectedFacilityType = +value;
        const returnedAccreditor = await AccreditorService.getAccreditorsByLocation(this.selectedRegion);
        this.FILTERED_ACCREDITORS = returnedAccreditor.filter((data) => {
          return data.isActive == true;
        });
      } else {
        this.showEduInstitutions = false;
        this.showAccreditor = false;
        this.showCpdProvider = false;
        this.showFacility = true;
        this.selectedFacilityType = +value;
        const returnedFacilities = await getUserFacilities(
            this.selectedRegion,
            this.selectedFacilityType
        );
        this.FILTERED_USER_FACILITIES = returnedFacilities.filter((data) => {
          return data.isActive == true;
        });

      }
      this.facilityLoading = false;
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateUser", this.formValues);
    }
  },
};
</script>

<style scoped>
.user-form__submit {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #ffffff !important;
}

.user-form__submit:hover {
  background: #1565c0 !important;
}

.user-form__shell {
  padding: 16px;
}

.user-form__grid {
  margin: 16px 24px 8px;
  row-gap: 16px;
}

.user-form__grid > div {
  margin-bottom: 0 !important;
}

.user-form__grid br {
  display: none;
}

.user-form__actions {
  margin: 12px 24px 20px;
  justify-content: flex-end;
}
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%);
  border-radius: 4px !important;
}

/* .input-icons i {
  position: absolute;
} */
.button {
  padding: 10px;
  min-width: 40px;
}

.input-field {
  width: 85%;
  padding: 10px;
}
</style>
